import React from 'react'
import { isEmpty, findIndex, propEq } from 'ramda'
import styled from 'styled-components'

import { placa } from 'consts/regexp'
import {
  filterProps,
  createFilters,
  toRankingOptions,
  formatFilters,
} from 'services/utils'

import { Tooltip } from '@material-ui/core'
import { Chip, SideBar, Ranking, SearchFilter } from 'components'
import { Trash } from 'components/Icons'

// --------------- 𝕄𝕖𝕥𝕒𝕕𝕒𝕥𝕒 ---------------

const AVAILABLE_FILTERS = ['dsc_uf', 'emp_cidade', 'emp_razao_social']

// --------------- 𝕌𝕥𝕚𝕝𝕤 ---------------

const createCollectsFilter = createFilters(AVAILABLE_FILTERS)

const removeElem = (elem, previousState) =>
  [...previousState].filter((e) => JSON.stringify(e) !== JSON.stringify(elem))

// --------------- ℂ𝕠𝕞𝕡𝕠𝕟𝕖𝕟𝕥𝕤 ---------------

const StyledTrashIcon = styled(Trash)`
  margin-right: 20px;

  cursor: pointer;
  path {
    fill: ${(props) => props.theme.palette.primary.main};
  }
`

// --------------- 𝕄𝕒𝕚𝕟 ---------------

export default function Filter({
  data,
  onFiltering,
  selectedFilters,
  ...props
}) {
  const rankings = createCollectsFilter(data)

  function handleClick(filter) {
    if (findIndex(propEq(filterProps.ID, filter.id), selectedFilters) === -1)
      onFiltering([...selectedFilters].concat(filter))
  }

  function handleDelete(filter) {
    onFiltering(removeElem(filter, [...selectedFilters]))
  }

  function handleSubmit(values) {
    onFiltering(formatFilters(values))
  }

  return (
    <SideBar
      {...props}
      // loading={loading}
      HeaderComponent={
        !isEmpty(selectedFilters) ? (
          <div className="ChipList ChipListSpacing">
            {selectedFilters.map((filter, index) => (
              <Chip
                onDelete={() => handleDelete(filter)}
                label={filter.value}
                key={index}
              />
            ))}
            <Tooltip title="Excluir filtros">
              <div>
                <StyledTrashIcon onClick={() => onFiltering([])} />
              </div>
            </Tooltip>
          </div>
        ) : null
      }
      ContentComponent={
        <div className="Ranking-List">
          <Ranking
            filterBy="customer_company.dsc_uf"
            title="Emitidas por UF"
            rows={toRankingOptions(rankings.dsc_uf)}
            onFiltering={handleClick}
          />
          <Ranking
            filterBy="customer_company.emp_cidade"
            title="Emitidas por Cidade"
            rows={toRankingOptions(rankings.emp_cidade)}
            onFiltering={handleClick}
          />
          <Ranking
            filterBy="customer_company.emp_razao_social"
            title="Emitidas por Cliente"
            rows={toRankingOptions(rankings.emp_razao_social)}
            onFiltering={handleClick}
          />
        </div>
      }
      FooterComponent={
        <SearchFilter
          onSubmit={handleSubmit}
          title="Pesquisar por"
          buttonLabel="Enviar"
          fields={[
            { name: 'vpt_motorista', label: 'Motorista' },
            {
              name: 'vpt_placa',
              label: 'Placa',
              textMaskProps: { mask: placa.array },
              uppercase: true,
            },
          ]}
        />
      }
    />
  )
}
